/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global document, Office */
const bootstrap = require("bootstrap");
import "@fortawesome/fontawesome-free/js/all.js";

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    document.getElementById("sideload-msg").style.display = "none";
    document.getElementById("app-body").style.display = "flex";
    document.getElementById("btn_translate").onclick = translate;
    document.getElementById("btn_rewrite").onclick = rewrite;
    document.getElementById("btn_summary").onclick = summary;
    document.getElementById("btn_ideas").onclick = ideas;
    document.getElementById("btn_search").onclick = search;
    document.getElementById("btn_feedback").onclick = feedback;
    document.getElementById("btn_roadmap").onclick = roadmap;
    document.getElementById("btn_disclaimer").onclick = disclaimer;
    document.getElementById("btn_copy").onclick = copyToClipboard;
    document.getElementById("btn_clear").onclick = clearInput;
    document.getElementById("btn_gpt_editor").onclick = gptEditorUI;
    document.getElementById("btn_whats_new").onclick = gotoRoadmap;
    document.getElementById("btn_gpt_editor_apply").onclick = GPTEditor;
    document.getElementById("btn_func_userguide").onclick = userguide;
    document.getElementById("btn_top_userguide").onclick = gotoUserguide;
  }

  isOutlookWeb().then((result) => {
    if (result) {
     $("#inputBox").attr("placeholder", "For Outlook Web, please paste your input here.");
    }
  })

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: "toast-bottom-right",
    preventDuplicates: false,
  };
});

function clearInput() {
  $("#inputBox").val("");
}

function gotoRoadmap() {
  $("#nav_about_tab").trigger("click");
  $("#btn_roadmap").trigger("click");
}

function gotoUserguide() {
  $("#nav_about_tab").trigger("click");
  $("#btn_func_userguide").trigger("click");
}

function gptEditorUI() {
  if ($("#btn_gpt_editor").hasClass("btn_gpt_editor_enable")) {
    if ($("#gtp_editor_container").hasClass("d-none")) {
      $("#gtp_editor_container").removeClass("d-none");
    } else {
      $("#gtp_editor_container").addClass("d-none");
    }
  }
}

function copyToClipboard() {
  var str = $("#outputBox").text();
  if (str.length > 0) {
    navigator.clipboard.writeText(str).then(
      function () {
        toastr.success("Text copyed.");
      },
      function () {
        toastr.error("Copy fail.");
      }
    );
  } else {
    toastr.info("Output is empty.");
  }
}

export function ideas() {
  var ideas = $("#sel_ideas option:selected").text();

  checkInput().then((result) => {
    if (result) {
      $("#outputBox").text("Processing with the Inputbox contents. \nPlease wait a moment...");
      if (ideas == "Brainstorm") {
        var body = {
          LFAIinput: "Please give some brainstorm ideas around the topic: " + $("#inputBox").val(),
        };
      }
      if (ideas == "Breakdown") {
        var body = {
          LFAIinput: "Please provide some actionable breakdown sub-tasks around the topic: " + $("#inputBox").val(),
        };
      }
      if (ideas == "Agenda") {
        var body = {
          LFAIinput: "Please draft a agenda for a discussion around the topic: " + $("#inputBox").val(),
        };
      }
      fetch("https://lfaihub.lfapps.net/api/common-LF-GPT-Oneshot/v1", {
        method: "POST",
        body: JSON.stringify(body),
        // Request headers
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log(json);
          logging("Ideas", ideas, json.LFAITokenTotal);
          $("#outputBox").text(json.LFAIoutput);
          $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
        })
        .catch((err) => {
          toastr.error(err);
          console.error(err);
        });
    }
})
}

export function GPTEditor() {
  var origin_output = $("#outputBox").text();

  checkInput().then((result) => {
    if (result) {
      var body = {
        messages: [
          {
            role: "system",
            content: "You are a helpful AI writer assistant.",
          },
          {
            role: "assistant",
            content: origin_output,
          },
          {
            role: "user",
            content: "Please help modify the previous message with below instructions: " + $("#GPTinputBox").val(),
          },
        ],
      };
      console.log(body);
      $("#outputBox").text("Processing with your request. \nPlease wait a moment...");
      fetch(
        "https://lfaihub.lfapps.net/api/common-AzureOpenAI-GPT-chat/v1",
        {
          method: "POST",
          body: JSON.stringify(body),
          // Request headers
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log(json);
          logging("Advanced", "GPT Editor", json.usage.total_tokens);
          $("#outputBox").text(json.choices[0].message.content);
          $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
        })
        .catch((err) => {
          toastr.error(err);
          console.error(err);
        });
    }
  })
}

export function search() {
  var selSearchval = $("#sel_search option:selected").val();
  var selSearchtext = $("#sel_search option:selected").text();

  checkInput().then((result) => {
    if (result) {
      var body = {
        LFAIinput: $("#inputBox").val(),
      };
      $("#outputBox").text("Processing with the Inputbox contents. \nPlease wait a moment...");
      console.log("clipboard copied, next to call api");
      console.log(selSearchval);
      if (selSearchval == "BingSearch") {
        fetch("https://lfaihub.lfapps.net/api/common-LF-GPT-iBing/v1", {
          method: "POST",
          body: JSON.stringify(body),
          // Request headers
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
          },
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            console.log(json);
            $("#outputBox").text(json.LFAIoutput);
            $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
            logging("Search", selSearchtext, json.LFAITokenTotal);
          })
          .catch((err) => {
            toastr.error(err);
            console.error(err);
          });
      }
      if (selSearchval == "ITServiceDeskKB") {
        fetch("https://lfaihub.lfapps.net/api/kb-ITSD/v1/", {
          method: "POST",
          body: JSON.stringify(body),
          // Request headers
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
          },
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            console.log(json);
            logging("Search", selSearchtext, json.LFAITokenTotal);
            $("#outputBox").text(json.LFAIoutput);
            $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
          })
          .catch((err) => {
            toastr.error(err);
            console.error(err);
          });
      }
    }
  })
  
}

export function rewrite() {
  var rewrite = $("#sel_rewrite option:selected").text();

  checkInput().then((result) => {
    if (result) {
      $("#outputBox").text("Processing with the Inputbox contents. \nPlease wait a moment...");
      if (rewrite == "Typo Correction") {
        var body = {
          LFAIinput: "Please correct the typo if any for below: " + $("#inputBox").val(),
        };
      }
      if (rewrite == "Native Speaker") {
        var body = {
          LFAIinput: "Please take the content between ##quote## as the input, and rewrite the input as of a native speaker ##quote## " + $("#inputBox").val() +" ##quote##"
        };
      }
      if (rewrite == "Shorter" || rewrite == "Longer") {
        var body = {
          LFAIinput: "Please draft a email about the topic, in a " + rewrite + " paragrah: " + $("#inputBox").val(),
        };
      }
  
      fetch("https://lfaihub.lfapps.net/api/common-LF-GPT-Oneshot/v1", {
        method: "POST",
        body: JSON.stringify(body),
        // Request headers
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log(json);
          logging("Rewrite", rewrite, json.LFAITokenTotal);
          $("#outputBox").text(json.LFAIoutput);
          $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
        })
        .catch((err) => {
          toastr.error(err);
          console.error(err);
        });
    }
  })
  
}

export async function translate() {
  var lang = $("#sel_language option:selected").val();

  checkInput().then((result) => {
    if (result) {
      $("#outputBox").text("Processing with the Inputbox contents. \nPlease wait a moment...");
      var body = {
        LFAIinput: "Please tranlate below into " + lang + " like a native speaker: " + $("#inputBox").val(),
      };
      fetch("https://lfaihub.lfapps.net/api/common-LF-GPT-Oneshot/v1", {
        method: "POST",
        body: JSON.stringify(body),
        // Request headers
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log(json);
          logging("Translate", lang, json.LFAITokenTotal);
          $("#outputBox").text(json.LFAIoutput);
          $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
        })
        .catch((err) => {
          toastr.error(err);
          console.error(err);
        });
    }
  })

  // Write message property value to the task pane
  // document.getElementById("Output").innerHTML = "<b>Subject:</b> <br/>" + httppost.json;
}

function summary() {
  var summary = $("#sel_summary option:selected").text();

  checkInput().then((result) => {
    if (result) {
      $("#outputBox").text("Processing with the Inputbox contents. \nPlease wait a moment...");
      var body = {
        LFAIinput: "Please summary below into clear " + summary + " form: " + $("#inputBox").val(),
      };
      fetch("https://lfaihub.lfapps.net/api/common-LF-GPT-Oneshot/v1", {
        method: "POST",
        body: JSON.stringify(body),
        // Request headers
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
          "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log(json);
          logging("Summary", summary, json.LFAITokenTotal);
          $("#outputBox").text(json.LFAIoutput);
          $("#btn_gpt_editor").removeClass("btn_gpt_editor_disable").addClass("btn_gpt_editor_enable");
        })
        .catch((err) => {
          toastr.error(err);
          console.error(err);
        });
    }
  })
  

  // Write message property value to the task pane
  // document.getElementById("Output").innerHTML = "<b>Subject:</b> <br/>" + httppost.json;
}

async function checkInput() {
  var check = true;
  try {
    const clipboard = await navigator.clipboard.readText();
    if ($("#inputBox").val() == "") {
      $("#inputBox").val(clipboard);
    }
  } catch(e) {

  }
  
  if ($("#inputBox").val() == "") {
    check = false;
    toastr.error("Input empty.");
  }
  return check;
}

function feedback() {
  $("#outputBox").text(
    "Feedback: \n Welcome for sharing with us any feedbacks / ideas / suggestions / use cases! \nPlease send an email to LFAICopilot@lifung.com"
  );
  if ($("#gtp_editor_container").hasClass("d-none")) {
  } else {
    $("#gtp_editor_container").addClass("d-none");
  }
  $("#btn_gpt_editor").addClass("btn_gpt_editor_disable").removeClass("btn_gpt_editor_enable");
}

function roadmap() {
  $("#outputBox").text(
    "Product Roadmap: \nPlanning: \n- LF AskPDF \n- Outlook Mobile adoption\n- UI/UX improvements \n- More LF Apps integrations \n \n Release Note: \n v1.3 \n - New Feature: Outlook Web support \n - UX improvment & bugfixes\nv1.2 \n - New Feature: Ideas (AI Functions)\n - New Feature: Rewrite: Typo Correction & Native Speaker \nv1.1 \n - New Feature: GPT Editor\n - UI improvements \nv1.0 \n- Basic AI functions \n- Reveal UI v1.0 \n- Reveal UI v0.2 \n- MVP v0.1"
  );
  if ($("#gtp_editor_container").hasClass("d-none")) {
  } else {
    $("#gtp_editor_container").addClass("d-none");
  }
  $("#btn_gpt_editor").addClass("btn_gpt_editor_disable").removeClass("btn_gpt_editor_enable");
}

function disclaimer() {
  $("#outputBox").text("Disclaimer: \nPlease validate the AI Generated Contents before making use of it.");
  if ($("#gtp_editor_container").hasClass("d-none")) {
  } else {
    $("#gtp_editor_container").addClass("d-none");
  }
  $("#btn_gpt_editor").addClass("btn_gpt_editor_disable").removeClass("btn_gpt_editor_enable");
}

function userguide() {
  $("#outputBox").text(
    "User Guide: \n1.	For the first time, need to Allow the clipboard access permission.\n 2.	For Outlook desktop users: To provide input, please select/highlight the target texts, Copy/CTRL-C, then click the functions. No need to Paste/CTRL-V, the add-in will read from the clipboard. \n3. For Outlook Web users, To provide input, please Copy and Paste the content into the input box, then click the functions. \n4.	Users can also edit the input text within the input box at any time, the Functions will take from the input box as final input.\n 5. The LF AI Assistant  supports Outlook Desktop/Mac/Web versions at this moment, Outlook Mobile support work in progress."
  );
  if ($("#gtp_editor_container").hasClass("d-none")) {
  } else {
    $("#gtp_editor_container").addClass("d-none");
  }
  $("#btn_gpt_editor").addClass("btn_gpt_editor_disable").removeClass("btn_gpt_editor_enable");
}


async function isOutlookWeb() {
  var result = false;
  if (typeof Office !== 'undefined' && Office.context && Office.context.platform === 'OfficeOnline') {
    console.log("Web version");
    result = true;
  } else {
      console.log("Desktop version");
  }
  return result;
}


function logging(functionGroup, FunctionName, Log_tokenusage) {
  var body = {
    "App_deployment": "PRD",
    "App_group": "AI WebApps",
    "App_name": "LF AI Assistant",
    "App_ownerteam": "CropApps",
    "Function_group": functionGroup,
    "Function_name": FunctionName,
    // "Log_otherinfo": "",
    "Log_tokenusage": Log_tokenusage,
    // "User_id": "",
    "User_input": $("#inputBox").val(),
    // "User_name": ""
  };

  fetch("https://lfaihub.lfapps.net/api/util-Logging/v1/", {
    method: "POST",
    body: JSON.stringify(body),
    // Request headers
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      "Ocp-Apim-Subscription-Key": "f5dff5b5b751453cbdca9d3e4ff9acc1",
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      console.log(json);
    })
    .catch((err) => {
      console.error(err);
    });
}